import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { controlPanel, qualifiers } from '../data/content';
export function Hero() {
  return <section id="top" className="border-b border-white/10" data-id="element-79" data-mp="9ktdnmoh20x8">
      <div className="mx-auto grid max-w-6xl gap-16 px-6 pb-24 pt-20 lg:grid-cols-12 lg:gap-12 lg:pb-28 lg:pt-28" data-id="element-80" data-mp="9lbeyxpzr5c0">
        <motion.div className="lg:col-span-7" initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-81" data-mp="4jm5vnmbx1qk">
          <p className="mb-8 text-sm text-zinc-500" data-id="element-82" data-mp="sbb39ie0cged">
            Growth Partner para marcas de suplementos y salud
          </p>

          <h1 className="max-w-3xl text-4xl font-semibold leading-[1.02] tracking-[-0.03em] text-white sm:text-5xl lg:text-[4.25rem]" data-id="element-83" data-mp="nczt16jsw3vm">
            Multiplica{' '}
            <span className="font-serif italic font-normal text-accent" data-id="element-84" data-mp="3cz5wsfzj282g">x7</span>{' '}
            tu facturación sin que el CPA se coma tu margen.
          </h1>

          <p className="mt-8 max-w-2xl text-lg leading-relaxed text-zinc-400" data-id="element-85" data-mp="3j925dog4jqvj">
            No gestiono anuncios: gestiono tu cuenta de resultados. Como Growth
            Partner opero las dos mitades del negocio —{' '}
            <span className="text-white" data-id="element-86" data-mp="39cfmh57cz9w5">adquisición rentable</span> para traer
            clientes por debajo de tu umbral de margen y{' '}
            <span className="text-white" data-id="element-87" data-mp="30hho3ilfz4xf">retención sistematizada</span> para que
            el segundo y tercer pedido paguen la escala. Una sola persona
            responsable del MER, del LTV y del AOV.
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-4" data-id="element-88" data-mp="2qkwiow5ifrt2">
            <CtaButton data-id="element-89" data-mp="2vievwyqk8t6v" />
            <p className="text-sm text-zinc-500" data-id="element-90" data-mp="2vjpxqt0g3qvc">
              30 minutos. Sin presentación de agencia.
            </p>
          </div>

          <ul className="mt-12 flex flex-wrap gap-x-6 gap-y-2 border-t border-white/10 pt-6" data-id="element-91" data-mp="2hlj8205ngx6r">
            {qualifiers.map(q => <li key={q} className="text-sm text-zinc-500" data-id="element-92" data-mp="s2jnvz2aw4kk">
                {q}
              </li>)}
          </ul>
        </motion.div>

        <motion.div className="lg:col-span-5 lg:pl-8" initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.08,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-93" data-mp="na0ap37izbga">
          <div className="border border-white/10 bg-ink-900 p-8" data-id="element-94" data-mp="1b0nhtm9m9x1s">
            <p className="text-xs uppercase tracking-[0.18em] text-zinc-500" data-id="element-95" data-mp="1ayt8l57pjtdj">
              Los números que gobiernan la escala
            </p>
            <dl className="mt-8 divide-y divide-white/10" data-id="element-96" data-mp="1126mye7k4yag">
              {controlPanel.map(metric => <div key={metric.label} className="flex items-baseline justify-between gap-4 py-4 first:pt-0 last:pb-0" data-id="element-97" data-mp="x1w7maxvkvix">
                  <div data-id="element-98" data-mp="3hrlmup2hqjc5">
                    <dt className="text-sm text-white" data-id="element-99" data-mp="3hr3q7rbx233p">{metric.label}</dt>
                    <p className="mt-1 text-xs text-zinc-500" data-id="element-100" data-mp="1x9ku2l5yd2go">{metric.note}</p>
                  </div>
                  <dd className="font-mono text-xl text-accent" data-id="element-101" data-mp="21amuh5blvkk8">{metric.value}</dd>
                </div>)}
            </dl>
            <p className="mt-8 border-t border-white/10 pt-6 text-sm leading-relaxed text-zinc-400" data-id="element-102" data-mp="2697m4gcskvx2">
              Si no puedes decir de memoria en qué MER dejas de ganar dinero,
              no tienes un problema de anuncios. Tienes un problema de
              estructura.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}